import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";

export function PrioritizeStage({ criteria, weights, setWeights, onSubmit }) {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="card-crisp p-6 sm:p-8"
      data-testid="prioritize-step"
    >
      <h2 className="font-display text-2xl font-bold tracking-tight">
        {t("workspace.prioritizeTitle")}
      </h2>
      <p className="mt-1.5 text-sm text-muted-foreground">{t("workspace.prioritizeSubtitle")}</p>
      <div className="mt-6 space-y-6">
        {criteria.map((c) => (
          <div key={c.id} data-testid={`priority-${c.id}`}>
            <div className="mb-2 flex items-center justify-between">
              <div>
                <span className="text-sm font-semibold">{c.name}</span>
                {c.description && (
                  <p className="text-xs text-muted-foreground">{c.description}</p>
                )}
              </div>
              <span className="font-mono text-sm font-bold text-ikb">
                {weights[c.id] ?? 3}
              </span>
            </div>
            <Slider
              value={[weights[c.id] ?? 3]}
              min={0}
              max={5}
              step={1}
              onValueChange={(v) => setWeights((p) => ({ ...p, [c.id]: v[0] }))}
              data-testid={`priority-slider-${c.id}`}
            />
          </div>
        ))}
      </div>
      <Button
        className="mt-8 w-full bg-primary text-primary-foreground hover:opacity-90"
        onClick={onSubmit}
        data-testid="run-analysis-btn"
      >
        <Zap className="mr-1.5 h-4 w-4" /> {t("workspace.runAnalysis")}
      </Button>
    </motion.div>
  );
}
